<template>
  <div>
    <v-row class="px-4 pt-4">
      <v-col>
        <v-card class="mb-4">
          <v-card-text>
            <v-row class="d-flex align-center">
              <v-col>
                <HolidaysFilters @filter="handleFilters" />
              </v-col>
              <v-col cols="auto">
                <Button
                  id="add-holiday-button"
                  color="primary"
                  @clickAction="isDialogOpened = true"
                >
                  {{ addHolidayText }}
                </Button>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="px-4 pb-4">
      <v-col>
        <v-card>
          <HolidaysTable @save="refreshHolidays" />
        </v-card>
      </v-col>
    </v-row>

    <AddHolidayDialog
      :is-opened="isDialogOpened"
      :locations="locations"
      @close="isDialogOpened = false"
      @save="refreshHolidays"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import { Button } from '@/components/shared';
import { loadingTypes } from '@/constants/loadingTypes';

import AddHolidayDialog from './AddHolidayDialog.vue';
import HolidaysFilters from './HolidaysFilters.vue';
import HolidaysTable from './HolidaysTable.vue';

export default {
  components: {
    AddHolidayDialog,
    Button,
    HolidaysFilters,
    HolidaysTable,
  },
  data() {
    return {
      isDialogOpened: false,
      addHolidayText: 'Add Holiday',
      loadingTypes,
      filters: {
        year: new Date().getFullYear(),
        location_id: null,
      },
    };
  },
  computed: {
    ...mapGetters('holidays/list', ['holidays']),
    ...mapGetters('shared/locations', ['locations']),
  },
  created() {
    this.getLocations();
    // Initial holidays load will be triggered by HolidaysFilters component
  },
  methods: {
    ...mapActions('holidays/list', ['getHolidays']),
    ...mapActions('shared/locations', ['getLocations']),
    handleFilters(filters) {
      this.filters = filters;
      this.getHolidays(filters);
    },
    refreshHolidays() {
      // Используем текущие фильтры при обновлении списка
      this.getHolidays(this.filters);
    },
  },
};
</script>
<style lang="less">
@import "~@/styles/actions-bar";
</style>
